export enum Currency {
    GBP = 'GBP',
    EUR = 'EUR',
}
